import { RESET_TRIGGER, SET_TRIGGER } from '../types/subscriptionTriggers.js';

export const setTrigger = (trigger) => {
  return {
    type: SET_TRIGGER,
    payload: trigger,
  };
};

export const resetTrigger = () => {
  return {
    type: RESET_TRIGGER,
  };
};
